export default __webpack_public_path__ + "static/cta-do-a60105ea5918af092774dfd0dd2612dd96b42b2c2e51eed6a5f4f0be7995653a.png";